import InputPhoto from './view/mobile';
export default InputPhoto;
